import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { UserProjectSummaryGetCollection, UserProjectSummaryGetCollectionResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<UserProjectSummaryGetCollectionResponse, UserProjectSummaryGetCollectionResponse>) => {
    return response?.data?.userProjectSummaries
}
const getError = (response?: SWRResponse<UserProjectSummaryGetCollectionResponse, UserProjectSummaryGetCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ContractGetCollectionByLotIdResponse, ContractGetCollectionByLotIdResponse>) => ({});

const useUserProjectSummaries = (configuration?: SWRConfiguration<UserProjectSummaryGetCollectionResponse, UserProjectSummaryGetCollectionResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new UserProjectSummaryGetCollection();
        };
    }, [configuration])

    return useGet(request, { getData, getError }, configuration);
}

export default useUserProjectSummaries;